import { render, staticRenderFns } from "./TableOfContentsItem.vue?vue&type=template&id=63d8e509&"
import script from "./TableOfContentsItem.vue?vue&type=script&lang=js&"
export * from "./TableOfContentsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports